import { z } from 'zod';
import { TMDXFile } from '@/api/apis/files';
import { OpoRoleEnum } from '@/api/apis/customer';
import { createOpoContactMembershipValidation, getPhoneSchema } from '@/utils/helpers';
import { CreateOpoContactFormValues, UpdateOpoContactFormValues } from './types';

const OPO_CONTACT_BASE_DEFAULTS = {
  isOpoUser: false,
  firstName: '',
  lastName: '',
  email: '',
  primaryPhone: '',
  secondaryPhone: '',
  memberships: [],
  inviteAsUser: false,
};

export const CREATE_OPO_CONTACT_FORM_DEFAULT_VALUES: CreateOpoContactFormValues = {
  ...OPO_CONTACT_BASE_DEFAULTS,
};

export const UPDATE_OPO_CONTACT_FORM_DEFAULT_VALUES: UpdateOpoContactFormValues = {
  ...OPO_CONTACT_BASE_DEFAULTS,
  isActive: true,
  inviteSent: false,
};

const membershipSchema = z.object({
  opoOrganizationId: z.string().min(1, 'OPO organization is required'),
  roles: z.array(z.enum(OpoRoleEnum)),
});

const opoContactSchemaBase = z.object({
  isOpoUser: z.boolean().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  photo: z.custom<TMDXFile>().optional(),
  photoPath: z.string().optional().nullable(),
  email: z.union([z.literal(''), z.email({ error: 'Invalid email' }), z.null()]).optional(),
  primaryPhone: getPhoneSchema({ isRequired: true }),
  secondaryPhone: getPhoneSchema({ isRequired: false }),
  memberships: z.array(membershipSchema),
  inviteAsUser: z.boolean().optional(),
});

export const createOpoContactFormSchema = opoContactSchemaBase.superRefine(createOpoContactMembershipValidation);

export const updateOpoContactFormSchema = opoContactSchemaBase
  .extend({
    isActive: z.boolean().optional(),
    inviteSent: z.boolean().optional(),
    userId: z.string().optional(),
  })
  .superRefine(createOpoContactMembershipValidation);
